export default __webpack_public_path__ + "static/media/travelex-logo-old.65199125.svg";